export { default, getServerSideProps } from "pages/[lang]/love";
